import { Checkbox } from "../../../../components/Checkbox";

export function MultiSelectLocationList({
    selected,
    setSelected,
    options,
    label,
}: {
    selected: string[];
    setSelected: (selected: string[]) => void;
    options: any[];
    label: string;
}) {
    const handleSelect = (option: any) => {
        if (selected.includes(option.value)) {
            setSelected(selected.filter((selectedOption) => selectedOption !== option.value));
        } else {
            setSelected([...selected, option.value]);
        }
    }
    return (
        <div className="flex-1 flex flex-col gap-2">
            <div className="flex flex-col">
                <div className="text-base font-medium">{label}</div>
                <div className="text-[#939393] text-xs">Select one or multiple</div>
            </div>
            <div className="flex flex-col gap-2 max-h-[175px] overflow-y-auto">
                {
                    options.map((option) => (
                        <Checkbox checked={selected.includes(option.value)} onChange={() => handleSelect(option)} label={option.label} id={option.value} key={option.value} />
                    ))
                }
                {
                    options.length === 0 && <div className="text-[#A2A2A2] w-full text-center text-[13px] leading-[15px] mt-4">No options found</div>
                }
            </div>
        </div>
    )
}